import { parseImage } from './Parser';
import { prepareUrl } from '../ajax/ajax';
import getToken from '../auth/token';
import { encode } from 'js-base64';
export const BlockTypes = {
    SceneHeading: 'scene-heading',
    Action: 'action',
    Empty: 'empty',
    CenteredAction: 'centered-action',
    Character: 'character',
    Parenthetical: 'parenthetical',
    Dialogue: 'dialogue',
    Transition: 'transition',
    PageBreak: 'page-break',
    Lyrics: 'lyrics',
    Header1: 'header-1',
    Header2: 'header-2',
    Header3: 'header-3',
    Header4: 'header-4',
    Header5: 'header-5',
    Header6: 'header-6',
    Synopsis: 'synopsis',
    Image: 'image',
};
function addEmphasis(text) {
    text = text.replace(/(?<!\\)\*\*\*(.*?)(?<!\\)\*\*\*/g, "<span class='emphasis emphasis--bold emphasis--italics'>--threestars--$1--threestars--</span>");
    text = text.replace(/(?<!\\)\*\*(.*?)(?<!\\)\*\*/g, "<span class='emphasis emphasis--bold'>--twostars--$1--twostars--</span>");
    text = text.replace(/(?<!\\)\*(.*?)(?<!\\)\*/g, "<span class='emphasis emphasis--italics'>--onestar--$1--onestar--</span>");
    text = text.replace(/--onestar--/g, "<span class='em-char'>*</span>");
    text = text.replace(/--twostars--/g, "<span class='em-char'>**</span>");
    text = text.replace(/--threestars--/g, "<span class='em-char'>***</span>");
    text = text.replace(/(?<!\\)_(.*?)(?<!\\)_/g, "--line--<span class='emphasis emphasis--underline'>$1</span>--line--");
    text = text.replace(/--line--/g, "<span class='em-char'>_</span>");
    text = text.replace(/(\[\[.*?]])/g, "<span class='note'>$1</span>");
    return text;
}
function addEmphasisPreview(text) {
    text = text.replace(/(?<!\\)\*\*\*(.*?)(?<!\\)\*\*\*/g, "<span class='emphasis emphasis--bold emphasis--italics'>$1</span>");
    text = text.replace(/(?<!\\)\*\*(.*?)(?<!\\)\*\*/g, "<span class='emphasis emphasis--bold'>$1</span>");
    text = text.replace(/(?<!\\)\*(.*?)(?<!\\)\*/g, "<span class='emphasis emphasis--italics'>$1</span>");
    text = text.replace(/(?<!\\)_(.*?)(?<!\\)_/g, "<span class='emphasis emphasis--underline'>$1</span>");
    text = text.replace(/(\[\[.*?]])/g, "");
    return text;
}
export default class Block {
    constructor(id, type, text) {
        this.id = id;
        this.type = type;
        this.text = text;
    }
    getId() {
        return this.id;
    }
    getType() {
        return this.type;
    }
    getText() {
        return this.text;
    }
    setText(text) {
        this.text = text;
    }
    renderInnerHTML() {
        if (this.type === BlockTypes.Empty && '  ' !== this.text) {
            return '<br>';
        }
        if (this.type === BlockTypes.Synopsis) {
            return '<span class="synopsis-indicator">=</span>' + this.text.substr(1);
        }
        if (this.type === BlockTypes.Image) {
            const image = parseImage(this.text);
            if (image) {
                return `<span>!</span>${image.path}<span>!</span><span>#</span>${image.caption}<span>#</span>`;
            }
        }
        return addEmphasis(this.text);
    }
    renderPreviewHTML(projectId) {
        if (this.type === BlockTypes.Empty && '  ' !== this.text) {
            return '<br>';
        }
        if (this.type === BlockTypes.CenteredAction) {
            return addEmphasisPreview(this.text.replace(/^>(.*)<$/g, "$1"));
        }
        if (this.type === BlockTypes.SceneHeading) {
            return addEmphasisPreview(this.text.replace(/^\.(.*)/g, "$1"));
        }
        if (this.type === BlockTypes.Action) {
            return addEmphasisPreview(this.text.replace(/^\!(.*)/g, "$1"));
        }
        if (this.type === BlockTypes.Character) {
            return addEmphasisPreview(this.text.replace(/^@(.*)/g, "$1"));
        }
        if (this.type === BlockTypes.Transition) {
            return addEmphasisPreview(this.text.replace(/^> (.*)/g, "$1"));
        }
        if (this.type === BlockTypes.Image) {
            const image = parseImage(this.text);
            if (image) {
                const realUrl = prepareUrl(`/projects/${projectId}/files/${encodeURIComponent(encode(image.path))}?token=${encodeURIComponent(getToken())}`);
                return `<figure><img src="${realUrl}" alt=""><figcaption>${image.caption}</figcaption></figure>`;
            }
        }
        return addEmphasisPreview(this.text);
    }
    getClassNames() {
        return ['Block', 'Block--' + this.type];
    }
    createBlockElement() {
        const element = document.createElement('div');
        element.classList.add(...this.getClassNames());
        element.innerHTML = this.renderInnerHTML();
        element.setAttribute('data-id', this.id);
        return element;
    }
    updateBlockElement(element) {
        if (element.getAttribute('data-id') !== this.id) {
            throw new Error(`Could not update element with ID ${element.getAttribute('data-id')}, tried to use block with different ID ${this.id}`);
        }
        element.setAttribute('class', this.getClassNames().join(' '));
        element.innerHTML = this.renderInnerHTML();
    }
}
